import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-259033aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-cap-title" }, "测试1", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("perm: p33 (visibility)")
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("perm: p1 (display)")
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("perm: p3 (enable)")
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_14 = { value: "perm: p44 (readonly)" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("doDelay1 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("重试大于10次停止重试")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("第二个请求")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 5 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mas_date_picker = _resolveComponent("mas-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_mas_button = _resolveComponent("mas-button")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", null, [
        _createElementVNode("span", null, "value0: " + _toDisplayString(_ctx.value0), 1),
        _hoisted_2,
        _createElementVNode("span", null, "account: " + _toDisplayString(_ctx.user), 1),
        _hoisted_3,
        _createElementVNode("span", null, "color: " + _toDisplayString(_ctx.pocketLabel("color", _ctx.currentColor)), 1),
        _hoisted_4,
        _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_6)), [
          [_directive_perm, 'p33', "visibility"]
        ]),
        _hoisted_7,
        _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_9)), [
          [_directive_perm, 'p1']
        ]),
        _hoisted_10,
        _withDirectives((_openBlock(), _createElementBlock("button", null, _hoisted_12)), [
          [_directive_perm, 'p3', "enable"]
        ]),
        _hoisted_13,
        _withDirectives(_createElementVNode("input", _hoisted_14, null, 512), [
          [_directive_perm, 'p44', "readonly"]
        ]),
        _hoisted_15,
        _createElementVNode("span", null, "api in progress: " + _toDisplayString(_ctx.apiProgress), 1),
        _hoisted_16,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.doPocket1 && _ctx.doPocket1(...args)))
        }, "doPocket1"),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.doPocket2 && _ctx.doPocket2(...args)))
        }, "doPocket2"),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doError1 && _ctx.doError1(...args)))
        }, "doError1"),
        _hoisted_17,
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.doTrack1 && _ctx.doTrack1(...args)))
        }, "doTrack1"),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.doDelay1 && _ctx.doDelay1(...args)))
        }, "doDelay1"),
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.exception && _ctx.exception(...args)))
        }, "exception"),
        _createVNode(_component_mas_date_picker, {
          mode: 3,
          onChange: _ctx.timeChange
        }, null, 8, ["onChange"]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, { onClick: _ctx.openApi }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, { onClick: _ctx.openApi1 }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_el_select, {
          modelValue: _ctx.value1,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.value1) = $event)),
          multiple: "",
          placeholder: "Select"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_mas_button, {
        type: "primary",
        id: "search",
        trackIngCategory: "Lead.DistribByHand.Distribution",
        trackingDesc: "测试埋点的按钮描述",
        onClick: _ctx.queryInfo
      }, {
        default: _withCtx(() => [
          _hoisted_20
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _hoisted_21
  ], 64))
}